import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=fbf0888c&scoped=true&lang=pug"
import script from "./Plan.vue?vue&type=script&lang=ts"
export * from "./Plan.vue?vue&type=script&lang=ts"
import style0 from "./Plan.vue?vue&type=style&index=0&id=fbf0888c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf0888c",
  null
  
)

export default component.exports